var render = function (_h,_vm) {var _c=_vm._c;return _c('p',_vm._g({staticClass:"reservation-menu-item",class:{'reservation-menu-item_active': _vm.props.active}},_vm.listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }